/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.clasesTecnicas': 'Clases  Tecnicas',
  'clasesTecnicas.agregarClases Tecnicas': 'Create Clases  Tecnicas',
  'clasesTecnicas.modificarClases Tecnicas': 'Edit Clases  Tecnicas',
  'clasesTecnicas.eliminarClases Tecnicas': 'Delete Clases  Tecnicas',
  'clasesTecnicas.claseTecnicaId': 'Clase   Tecnica   Id ',
  'clasesTecnicas.empresaId': ' Empresa   Id ',
  'clasesTecnicas.claseTecnicaDescripcion': 'Text',
  'clasesTecnicas.clases Tecnicas': 'Tecnical  Class',
  'clasesTecnicas.verClases Tecnicas': 'View Clases  Tecnicas',
};
